<template v-if="loading">
  <v-container>
    <v-card>
      <v-container>
        <v-card-title>
          <!-- 取引先
          <v-spacer></v-spacer>-->
          <v-text-field v-model="search" label="会社名検索" single-line hide-details></v-text-field>
          <!-- append-icon="search"-->
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="makers"
          :search="search"
          :custom-sort="customSort"
          hide-actions
        >
          <template v-slot:items="props">
            <tr @click="forwardMakerEdit(props.item)">
              <td>{{ props.item.makerId }}</td>
              <td class="text-xs-left">{{ props.item.makerName }}</td>
              <td class="text-xs-left">{{ props.item.tel }}</td>
              <td class="text-xs-left">{{ props.item.address }}</td>
              <td class="text-xs-left" v-if="props.item.isDeleted === '0'">有効</td>
              <td class="text-xs-left" v-else>無効</td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert
              :value="true"
              color="error"
              icon="warning"
            >検索キーワード["{{ search }}]に該当する製造会社名は存在しません</v-alert>
          </template>
        </v-data-table>
        <br />
      </v-container>
    </v-card>

    <br />
    <v-layout row wrap>
      <v-flex xs12 sm5>
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
        </v-btn>
      </v-flex>
      <v-flex xs12 sm2></v-flex>
      <v-flex xs12 sm5>
        <v-btn block color="success" dark :to="{ name: 'admin/makers/new' }">
          <v-icon dark left>create</v-icon>新規登録
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
export default {
  created() {
    console.log('created')
    let thisObj = this

    ServerApiCallService.makers()
      .then(response => {
        thisObj.makers = response.data.makers
        // 初期表示時の
        thisObj.loading = false
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
  },
  methods: {
    customSort(items, index, isDesc) {
      console.log('custom sort. makerId ')

      items.sort((a, b) => {
        if (!isDesc) {
          if (a.makerId < b.makerId) {
            return -1
          } else if (a.makerId > b.makerId) {
            return 1
          }
        } else {
          if (a.makerId < b.makerId) {
            return 1
          } else if (a.makerId > b.makerId) {
            return -1
          }
        }
        return 0
      })
      return items
    },
    forwardMakerEdit(makerInfo) {
      // newMakerRegist에 값을 넘김
      this.$router.push({
        name: 'admin_makers_update',
        params: { makerId: makerInfo.makerId }
      })
    }
  },
  data() {
    return {
      loader: null,
      loading: true,
      search: '',
      headers: [
        { text: '製造会社コード', value: 'makerId' },
        { text: '製造会社名', value: 'makerName', sortable: false },
        { text: '連絡先', value: 'tel', sortable: false },
        { text: '住所', value: 'address', sortable: false },        
        { text: 'ステータス', value: 'isDeleted', sortable: false }
      ],
      makers: []
    }
  }
}
</script>
